import { configureStore } from '@reduxjs/toolkit'
import engineSlice from './features/engine/engineSlice'
import pricingToolSlice from './features/pricingTool/pricingToolSlice'

export const store = configureStore({
  reducer: {
    engine: engineSlice,
    pricingTool: pricingToolSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch